/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupenable1Inputs */

const en_signupenable1 = /** @type {(inputs: Signupenable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on sign-up`)
};

const de_signupenable1 = /** @type {(inputs: Signupenable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung einschalten`)
};

/**
* | output |
* | --- |
* | "Turn on sign-up" |
*
* @param {Signupenable1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupenable1 = /** @type {((inputs?: Signupenable1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupenable1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupenable1(inputs)
	return de_signupenable1(inputs)
});
export { signupenable1 as "signupEnable" }